export default {
  common: {
    scrollToFocus: 'навести фокус',
    clickPhoto: 'клікай на фото',
    return: 'назад',
    tuneIn: 'увімкнути звук',
  },
  IntroRoom: {
    projectName: 'ОКОЛИЦІ часу',
    headphonesOn: 'Будь ласка, надіньте навушники',
    letsGoStartIt: 'Почати тут',
    instruction: 'Інструкція',
    aboutProject: `
  “Околиці часу” - це мистецько-дослідницький проект, під час якого автори досліджували історії людей, спосіб життя та професії яких, вірогідно, зникнуть в найближче сторіччя. 
Сьогодні однією з головних тенденцій та, можливо, одним з головних викликів для сучасної людини стає необхідність роззирнутися та переусвідомити досвід в абсолютно різних проявах людської діяльності. Зупинитися та вдумливо розгледіти, дослідити те, що відбулося та відбувається. Бо темп надто шалений. Разом з прогресом світ змінюється, збільшуються потоки інформації, зникають професії, нове витісняє старе - та чи встигаємо ми осмислити цей процес та те, що кожного дня стає минулим?
Герої нашого проекту в своїй більшості - це люди, які живуть в іншому часовому та інформаційному просторі, ніж мешканці великих міст. 
Вони - представники щезаючих професій, і саме через їх історії ми бачимо, як старі технології, а разом з ними і спосіб життя та мислення, поступово відходять у минуле. Цей проект - спроба зафіксувати та втримати перехід сучасного світу в інший інформативний та часовий простір.
В онлайн-виставці використані автентичні документальні тексти та збережена оригінальна мова кожного героя.
Проект був реалізовуваний на території України: Київ, Полісся (Перга, Копище, Майдан), Одеса, Карпати (Ворохта, Яворів, Космач, Микуличин), Дрогобич, Донбас (місто Торецьк, Щербинівка) та Тендрівська коса. “Околиці часу” створювався за підтримки Українського Культурного Фонду.
    `,
    guidance: `
  Для того, щоб ваш досвід був повноцінним, ми просимо вас: \n
  розгорнути сторінку на весь екран
  надягнути навушники \n
  Кожна глава побудована нами для вас як історія та має свій ритм. \n
  Тому ми рекомендуємо вам дивитись і слухати главу від початку до кінця, \n
  але якщо ви захочете затриматись на фотографії або перегорнути, то в правому нижньому куті екрану
  є навігація, яка допоможе вам. \n
  Дякуємо за розуміння.
  Приємного перегляду.
    `,
  },
  Mobile: {
    part1: 'ПРОЕКТ створено для перегляду на більшому екрані',
    part2: 'будь ласка, використовуйте комп’ютер та навушники!',
    thanks: 'Дякуємо!',
  },
  lastRoom: {},
}
